module.exports = __webpack_public_path__ + "media/images/web/home/specs/spec_streaming_1-7cb940ada32335ddf8212ee20df03813.jpg";